import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-918c023a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "search-input" }
const _hoisted_3 = { class: "ceci-list" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "ceci-item" }
const _hoisted_6 = {
  key: 0,
  class: "paper-preview"
}
const _hoisted_7 = { key: 1 }

import { ref, watchEffect } from 'vue'
import { getPaper } from '@/api/common'
import { ERR_SUCCESS } from '@/api/config'
import PaperPreview from '@/components/paper/PaperPreview.vue'
import { PaperConfig } from '@/types'
import Pagination from '@/components/common/Pagination.vue'
import { Pane, Splitpanes } from 'splitpanes'
import 'splitpanes/dist/splitpanes.css'
import debounce from 'lodash/debounce'


export default /*#__PURE__*/_defineComponent({
  __name: 'paperList',
  props: ['singleSelect', 'multipleSelect', 'area'],
  setup(__props) {

const dataList = ref<PaperConfig[]>([])
const currentPage = ref<number>(1)
const pageSize = ref<number>(12)
const totalSize = ref<number>(0)
const currentPaper = ref<PaperConfig | null>(null)
const selectedIndex = ref(0)
const searchKeyword = ref('')
const keyword = ref('')

const props = __props

function handleKeywordChange () {
  searchKeyword.value = keyword.value
}

const debouncedHandleKeywordChange = debounce(handleKeywordChange, 1000)

async function fetchData () {
  const {
    subject = null,
    period = null
  } = props.singleSelect || {}
  const {
    platform = [],
    edition = [],
    grade = [],
    term = []
  } = props.multipleSelect || {}

  try {
    const params = {
      page: currentPage.value,
      pageSize: pageSize.value,
      platform: Array.isArray(platform) ? platform.join(',') : platform,
      grade: Array.isArray(grade) ? grade.join(',') : grade,
      edition: Array.isArray(edition) ? edition.join(',') : edition,
      term: Array.isArray(term) ? term.join(',') : term,
      papercontent: searchKeyword.value,
      period,
      subject,
      area: Array.isArray(props.area) ? props.area.join(',') : props.area
    }
    const {
      code,
      result: {
        items: data,
        total
      }
    } = await getPaper({ params })
    if (code === ERR_SUCCESS && data) {
      const paperList = data.map(obj => {
        if (obj.papercontent) {
          obj.papercontent = obj.papercontent.replace(/ src=/g, ' src_url=')
        } else {
          obj.papercontent = ''
        }
        return obj
      })
      dataList.value = paperList
      currentPaper.value = paperList[0]
      totalSize.value = total
      selectedIndex.value = 0
    }
  } catch (error) {
    console.error('Error fetching data:', error)
  }
}

async function preview (item: PaperConfig | null, index: number) {
  selectedIndex.value = index
  currentPaper.value = item
}

watchEffect(() => {
  fetchData()
})


return (_ctx: any,_cache: any) => {
  const _component_Search = _resolveComponent("Search")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_text = _resolveComponent("el-text")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Splitpanes), {
      class: "default-theme",
      horizontal: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Pane), {
          class: "top-pane",
          "max-size": "50",
          size: "20"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_el_input, {
                modelValue: keyword.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((keyword).value = $event)),
                clearable: "",
                placeholder: "关键词 ...",
                onChange: _unref(debouncedHandleKeywordChange)
              }, {
                append: _withCtx(() => [
                  _createVNode(_component_el_icon, {
                    type: "button",
                    onClick: handleKeywordChange
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Search)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue", "onChange"])
            ]),
            _withDirectives(_createElementVNode("div", null, [
              _createVNode(_component_el_empty, {
                "image-size": 100,
                description: "暂无数据"
              })
            ], 512), [
              [_vShow, dataList.value.length === 0]
            ]),
            _createElementVNode("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataList.value, (data, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: _normalizeClass({ 'active-item': selectedIndex.value === index }),
                  onClick: ($event: any) => (preview(data, index))
                }, [
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_el_tag, {
                      size: "large",
                      type: "primary"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(index + 1), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_el_text, { "line-clamp": "2" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(data.papername), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ])
                ], 10, _hoisted_4))
              }), 128))
            ]),
            _createVNode(Pagination, {
              "current-page": currentPage.value,
              "onUpdate:currentPage": _cache[1] || (_cache[1] = ($event: any) => ((currentPage).value = $event)),
              "page-size": pageSize.value,
              "onUpdate:pageSize": _cache[2] || (_cache[2] = ($event: any) => ((pageSize).value = $event)),
              "total-size": totalSize.value
            }, null, 8, ["current-page", "page-size", "total-size"])
          ]),
          _: 1
        }),
        _createVNode(_unref(Pane), { class: "bottom-pane" }, {
          default: _withCtx(() => [
            (currentPaper.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createVNode(PaperPreview, {
                    item: currentPaper.value,
                    "search-keyword": searchKeyword.value
                  }, null, 8, ["item", "search-keyword"])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createVNode(_component_el_empty, {
                    "image-size": 300,
                    description: "点击左侧资源查看详情"
                  })
                ]))
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})